import { Sentry } from 'app/utils/sentry';
/** Simple wrapper to add a Sentry breadcrumb before throwing an error */
export function ElevioError({ feature, context, message, }) {
    const errorMessage = `${context}: ${message}`;
    Sentry.addBreadcrumb({
        category: `elevio.${feature}`,
        message: errorMessage,
    });
    return new Error(errorMessage);
}
